/* istanbul ignore file */
import { createSelector } from '@ngrx/store';
import { getTestMonkeyState } from '@store/reducers/index';

import { TestMonkeyState } from '../reducers/test-monkey.reducer';

export const selectTestMonkeyState = createSelector(
  getTestMonkeyState,
  (state: TestMonkeyState) => {
    return state;
  },
);

export const selectTestMonkeyResponses = createSelector(
  getTestMonkeyState,
  (state: TestMonkeyState) => {
    return state.responses;
  },
);

export const selectTestMonkeyBranches = createSelector(
  getTestMonkeyState,
  (state: TestMonkeyState) => {
    return state.branches;
  },
);
